
    import { mapState, mapActions } from 'vuex';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import has from 'lodash/has';
    import { faSpinner as fasSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import EmailDebounceMixin from '@/components/AuthCommon/EmailDebounceMixin.vue';
    import C1FormInput from '@/C1Components/C1FormInput';
    import C1Alert from '@/C1Components/C1Alert';

    export default {
        name: 'AuthRegister',

        components: {
            ValidationObserver,
            ValidationProvider,
            C1FormInput,
            C1Alert,
            FontAwesomeIcon,
        },

        mixins: [EmailDebounceMixin],

        props: {
            email: {
                type: String,
                default: '',
            },

            color: {
                type: String,
                default: 'blue',
            },

            hideLabels: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                password: '',
                response: {
                    message_title: '',
                    message: '',
                },
                spinner: {
                    register: false,
                },
                form: {
                    email: '',
                    first_name: '',
                    last_name: '',
                    password: '',
                    recaptcha_disable: true,
                },
                formRegister: {},
                icons: {
                    fasSpinner,
                },
            };
        },

        computed: {
            ...mapState({
                $_apiMessage: state => state.apiMessage,
                $_authOptions: state => state.auth.authOptions,
                $_isEmailValidating: state => state.auth.isEmailValidating,
            }),
        },

        methods: {
            ...mapActions('auth', {
                $_authRegister: 'register',
            }),

            ...mapActions('log', {
                $_storeLog: 'storeLog',
            }),

            async register() {
                if (!this.isEmailForced) {
                    await this.debounceValidateEmail(this.email);
                }
                const validate = await this.$refs.formRegister.validate();
                if (!validate) {
                    this.$emit('validate');
                    return;
                }
                this.form.email = this.email;
                this.form.site_position = 'auth_register';
                this.form.current_url = window.location.href;
                if (this.isEmailForced || this.isEmailValid) {
                    this.$_register(this.form);
                }
            },

            $_register(data) {
                this.spinner.register = true;

                this.$_authRegister(data).then((response) => {
                    this.$emit('afterRegister', response);
                }).catch((error) => {
                    const errorCode = has(error, 'response.data.error') ? error.response.data.error : 'ServerErrorException';
                    this.response.message_title = 'Register failed';
                    this.response.message = this.$_apiMessage[errorCode];
                    this.spinner.register = false;

                    if (error && error.config) {
                        // Remove password property from error data
                        const configData = JSON.parse(error.config.data);
                        delete configData.password;
                        error.config.data = JSON.stringify(configData);

                        // debug device
                        error.config.device = this.$device;
                    }

                    const errorData = {
                        application_code: 'seeker',
                        context: 'seeker-register',
                        message: JSON.stringify(error),
                    };
                    this.$_storeLog(errorData);
                });
            },

            onInputChanged() {
                this.$emit('validate');
            },
        },
    };
